import { Attributes } from '../attributes';
import { SUB_CATEGORY } from '../categories';

export const EXTENDED_ATTRIBUTES_PREFIX = 'extended_attributes';

/**
 *  Get valid metadata attributes. A metadata attribute will be valid in case it has
 *  a title translation as well as for all of it's options.
 */
export const getValidMetadataAttributes = (i18n, metadataAttributes, subCategoryId) => metadataAttributes ?
    metadataAttributes.filter(
        (metadataAttribute) => isValidMetadataAttribute(i18n, metadataAttribute, subCategoryId)
    ) : [];

const isValidMetadataAttribute = (i18n, metadataAttribute, subCategoryId) => {
    if (!metadataAttribute) {
        return false;
    }

    const { name, options } = metadataAttribute;
    const isTitleValid = name && i18n.has(getAttributeTitleKey(name, subCategoryId));
    const isOptionsValid = options && options.every((option) =>
        i18n.has(getAttributeOptionKey(name, option, subCategoryId))
    );

    return isTitleValid && isOptionsValid;
};

export const getAttributeTitleKey = (name, subCategoryId) =>
    `${getExtendedAttributeKey(name, subCategoryId)}.${Attributes.title}`;

export const getAttributeOptionKey = (name, option, subCategoryId) =>
    `${getExtendedAttributeKey(name, subCategoryId)}.${Attributes.options}.${option}`;

const getExtendedAttributeKey = (name, subCategoryId) =>
    `${EXTENDED_ATTRIBUTES_PREFIX}.${SUB_CATEGORY}_${subCategoryId}.${name}`;
